export interface IPartner {
  id?: number;
  name?: string;
}

export const defaultValue: Readonly<IPartner> = {};
